module.exports = __webpack_public_path__ + "static/media/forbes.6ec4e890.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SkyminerLanding/images/forbes.svg
// module id = 1177
// module chunks = 0